import translations from './landingTranslations.json';

export function detectLandingLanguage(languages) {
  const preferences = languages ?? (typeof navigator === 'undefined'
    ? [] : (navigator.languages?.length ? navigator.languages : [navigator.language]));
  for (const preference of preferences) {
    const language = String(preference).toLowerCase().split(/[-_]/)[0];
    if (Object.prototype.hasOwnProperty.call(translations, language)) return language;
  }
  return 'es';
}

export function translateLanding(language, text, catalog = translations) {
  return catalog[language]?.[text] ?? catalog.es?.[text] ?? text;
}
